import React from 'react';

import QuestionLabel from './Components/QuestionLabel';

export default function PainScaleProperties({ question }) {
  return <>
    <h1>Pain Scale</h1>

    <QuestionLabel question={question} />
  </>
};